import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    init: function() {
      const compareProducts = JSON.parse( sessionStorage.getItem( 'compareProducts' ) || '[]' );
      document.addEventListener( 'click', ( e ) => {
        if ( e.target.matches( '#js-comparison-remove-all' ) ) {
          sessionStorage.removeItem( 'compareProducts' );
          document.querySelector( '.product-comparison' ).innerHTML = '';
          this.load( [] );
        }
      } );
      if ( compareProducts.length > 0 ) {
        this.load( compareProducts );
      }
    },
    load: function( products ) {
      fetch( `${siteInfo.wpApiSettings.ll}product-comparison`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': siteInfo.wpApiSettings.nonce,
        },
        body: JSON.stringify( {
          products: products,
        } ),
      } ).then( ( response ) => {
        if ( response.ok ) {
          response.json().then( ( data ) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString( data.html, 'text/html' );
            const productHtml = doc.querySelector( '.product-comparison' );
            document.querySelector( '.product-comparison' ).innerHTML = productHtml.innerHTML;
          } );
        }
      } ).then( () => {
        setTimeout( () => {
          this.mount();
          setTimeout( () => {
            this.equalizeHeights();
          }, 100 );
        }, 100 );
      } );
    },
    equalizeHeights: function() {
      const groups = {};
      document.querySelectorAll( '.comparison-info[data-group]' ).forEach( ( item ) => {
        const group = item.dataset.group;
        if ( !groups[group] ) groups[group] = [];
        groups[group].push( item );
      } );

      Object.values( groups ).forEach( ( items ) => {
        const maxHeight = Math.max( ...items.map( ( item ) => item.offsetHeight ) );
        items.forEach( ( item ) => item.style.height = `${maxHeight}px` );
      } );
    },

    mount: function() {
      $( '.product-comparison-products' ).each( ( key, element ) => {
        const slider = new Splide( element, {
          type: 'slide',
          perPage: 4,
          arrows: false,
          pagination: false,
          perMove: 1,
          breakpoints: {
            640: {
              perPage: 1,
            },
            786: {
              perPage: 2,
            },
            1270: {
              perPage: 3,
            },
          },
        } ).mount();

        const prevButton = element.closest( '.product-comparison' ).querySelector( '.product-comparison-nav-prev' );
        const nextButton = element.closest( '.product-comparison' ).querySelector( '.product-comparison-nav-next' );

        const updateButtonStates = () => {
          const currentIndex = slider.index;
          const firstIndex = 0;
          const lastIndex = slider.Components.Controller.getEnd();

          prevButton.classList.toggle( 'is-disabled', currentIndex === firstIndex );
          nextButton.classList.toggle( 'is-disabled', currentIndex === lastIndex );
        };

        updateButtonStates();

        prevButton.addEventListener( 'click', () => {
          slider.go( '<' );
        } );

        nextButton.addEventListener( 'click', () => {
          slider.go( '>' );
        } );

        slider.on( 'moved', updateButtonStates );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'product-comparison', COMPONENT );
} )( app );
